import { ReactElement } from 'react';

import { SvgIcon } from '@mui/material';

export const Icon = ({
  icon,
  color = '#FFFFFF',
}: {
  icon: ReactElement;
  color?: string;
}) => {
  return (
    <SvgIcon
      sx={{
        path: {
          fill: color,
        },
      }}
    >
      {icon}
    </SvgIcon>
  );
};
